import React, { lazy } from 'react';
const cld = (path: string) => `https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_300,c_limit/${path}`;
const upsellTomes = [{
  number: 'U1',
  title: 'Laboratorio y Clínica Profunda',
  desc: 'Interpretación funcional: HOMA-IR, ferritina, tiroides y más.',
  image: cld('v1778383928/hf_20260510_032056_bdcf6902-24e4-45c1-9723-9367d30d03c6_lwdiq9.webp')
}, {
  number: 'U2',
  title: 'Suplementación Clínica Argentina',
  desc: 'Dosis exactas y marcas disponibles en Argentina con evidencia real.',
  image: cld('v1778383932/hf_20260510_032107_c079660a-2b86-4a69-8d1c-65c34f3c632e_tncrbi.webp')
}, {
  number: 'U3',
  title: 'Especialización de Alto Valor',
  desc: 'Nutrición estética, deportiva y hormonal femenina.',
  image: cld('v1778383936/hf_20260510_032120_a088f605-c4cb-480f-9715-be1223f27274_jjfjzi.webp')
}, {
  number: 'U4',
  title: 'Modelo de Negocio y Programas',
  desc: 'Programas de 12 semanas, grupos y red de referidos médicos.',
  image: cld('v1778383940/hf_20260510_032130_0a38f9a8-45e4-441b-a4e3-855fbb11cb59_n1guyx.webp')
}];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(220,252,231) 50%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-389">
      <div className="mx-auto max-w-4xl" data-id="element-390">
        {/* Level Badge */}
        <div className="flex items-center justify-center mb-4" data-id="element-391">
          <span className="text-[10px] font-black text-white rounded-full px-3 py-1 tracking-wide" style={{
          backgroundImage: 'linear-gradient(135deg, rgb(20,83,45) 0%, rgb(21,128,61) 100%)'
        }} data-id="element-392">
            NIVEL 2
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-393">
          ⭐ Autoridad <span className="text-green-700" data-id="element-394">Nutricional</span>
        </h2>
        <p className="text-center text-sm text-gray-600 m-0 mb-2" data-id="element-395">
          El Megapack Nutrición Resuelta completo, más 4 tomos de
          especialización clínica para diferenciarte de verdad.
        </p>
        <p className="text-center text-xs font-semibold text-green-700 m-0 mb-6" data-id="element-396">
          6 Tomos + 6 Bonos + 4 Tomos de Especialización · +700 páginas en total
        </p>

        {/* Incluye nivel 1 banner */}
        <div className="flex items-center gap-3 rounded-xl px-5 py-3 mb-6 shadow-sm" style={{
        backgroundColor: 'rgb(240,253,244)',
        border: '1px solid rgba(34,197,94,0.3)'
      }} data-id="element-397">
          <span className="text-lg shrink-0" data-id="element-398">✅</span>
          <div data-id="element-399">
            <p className="text-xs font-black text-green-700 uppercase tracking-wide m-0" data-id="element-400">
              Megapack Nutrición Resuelta incluido
            </p>
            <p className="text-xs text-gray-500 font-medium m-0 mt-0.5" data-id="element-401">
              Los 6 Tomos clínicos + los 6 Bonos estratégicos del Nivel 1, más
              los 4 tomos de especialización que ves abajo.
            </p>
          </div>
        </div>

        {/* Grid portadas */}
        <div className="grid grid-cols-4 gap-3 mb-8" data-id="element-402">
          {upsellTomes.map(tome => <div key={tome.number} className="flex flex-col items-center gap-1.5" data-id="element-403">
              <div className="w-full aspect-[3/4] rounded-xl border overflow-hidden" style={{
            backgroundImage: 'linear-gradient(135deg, rgba(20,83,45,0.08) 0%, rgba(21,128,61,0.15) 100%)',
            borderColor: 'rgba(20,83,45,0.2)'
          }} data-id="element-404">
                {tome.image ? <img src={tome.image} alt={tome.title} width="150" height="200" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-405" /> : <div className="w-full h-full flex items-center justify-center" data-id="element-406">
                    <span className="text-2xl font-black" style={{
                color: 'rgba(20,83,45,0.25)'
              }} data-id="element-407">
                      {tome.number}
                    </span>
                  </div>}
              </div>
              <span className="text-[10px] font-black text-gray-800 text-center leading-tight" data-id="element-408">
                {tome.title}
              </span>
              <span className="text-[9px] text-gray-400 text-center leading-tight" data-id="element-409">
                {tome.desc}
              </span>
            </div>)}
        </div>

        {/* Footer bar */}
        <div className="text-center rounded-xl px-5 py-4 shadow-sm" style={{
        backgroundImage: 'linear-gradient(135deg, rgba(20,83,45,0.06) 0%, rgba(21,128,61,0.10) 100%)',
        border: '1px solid rgba(20,83,45,0.2)'
      }} data-id="element-410">
          <p className="text-xs font-bold uppercase tracking-widest m-0 mb-1" style={{
          color: 'rgb(20,83,45)'
        }} data-id="element-411">
            Para la nutricionista que quiere ser referente
          </p>
          <p className="text-sm text-gray-700 font-semibold m-0" data-id="element-412">
            Especialización clínica real · Nichos de alto valor · Negocio
            escalable
          </p>
          <p className="text-[11px] text-gray-400 font-medium m-0 mt-1" data-id="element-413">
            El nivel que te separa del resto.
          </p>
        </div>
      </div>
    </section>;
}